'use client';

import { callToActionCardsGridSection } from '@stereoagency/sanity-schema';
import { LabeledCallToActionCardsGridSection } from '@stereoagency/ui';
import flush from 'just-flush';
import { SimpleBlockContent } from '../sanity/client';
import { actionAsProps } from '@/utils';

type Props =
  typeof callToActionCardsGridSection.schema.callToActionCardsGridSection;

export default function CallToActionCardsGridSection({ title, description, cards }: Props) {
  if (!cards?.length) {
    return null;
  }

  return (
    <LabeledCallToActionCardsGridSection
      title={title}
      description={
        description ? <SimpleBlockContent value={description ?? []} /> : null
      }
      cards={flush(
        cards.map((card) => {
          if (!card.title || !card.action || !card.actionLabel) {
            return null;
          }

          return {
            title: card.title,
            label: card.actionLabel,
            action: actionAsProps(card.action),
            description: card.description ? (
              <SimpleBlockContent value={card.description} />
            ) : null
          };
        })
      )}
    />
  );
}
